import { BaseRequest } from './BaseRequest';

export class ActiveCampaignDeliveryReportRequest extends BaseRequest {
  CampaignId: string | number;
}
